class DocManagementService {
	async createFolder(data) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/folders`, {
			method: 'POST',
			headers: {
				'Content-type': 'application/json',
			},
			body: JSON.stringify(data),
		})

		return response.json()
	}

	async findFolders(companyId) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/folders/${companyId}`, {
			method: 'GET',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}

	async findFoldersEmployee(employeeId) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/folders_employee/${employeeId}`, {
			method: 'GET',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}

	async findFolder(companyId, folderId) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/folder/${companyId}?folderId=${folderId}`, {
			method: 'GET',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}

	async findArrayFolders(companyId, foldersId) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/folder/${companyId}?folderId=${foldersId}`, {
			method: 'GET',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}

	async deleteFolder(folderId) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/folders/${folderId}`, {
			method: 'DELETE',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}

	async moveFolder(folderId, data) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/folders/${folderId}`, {
			method: 'PUT',
			headers: {
				'Content-type': 'application/json',
			},
			body: JSON.stringify(data),
		})

		return response.json()
	}

	async updateFolder(folderId, data) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/folders/${folderId}`, {
			method: 'PUT',
			headers: {
				'Content-type': 'application/json',
			},
			body: JSON.stringify(data),
		})

		return response.json()
	}

	async listAllFolders(companyId) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/list_folders/${companyId}`, {
			method: 'GET',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}

	async uploadDocuments(data) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/documents`, {
			method: 'POST',
			headers: {
				'Content-type': 'application/json',
			},
			body: JSON.stringify(data),
		})

		return response.json()
	}

	async uploadDocumentsEmp(data) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/documents_employee`, {
			method: 'POST',
			headers: {
				'Content-type': 'application/json',
			},
			body: JSON.stringify(data),
		})

		return response.json()
	}

	async deleteDocument(documentId) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/documents/${documentId}`, {
			method: 'DELETE',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}
	async moveDocument(documentId, data) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/documents/${documentId}`, {
			method: 'PUT',
			headers: {
				'Content-type': 'application/json',
			},
			body: JSON.stringify(data),
		})

		return response.json()
	}
}
export default new DocManagementService()
